module.exports = __webpack_public_path__ + "static/media/Super Over one day.73471811.jpg";